import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["deliveryPanel", "pickupPanel", "pickupHint"]

  static values = {
    points: Object
  }

  connect() {
    this.toggle()
  }

  toggle() {
    const isPickup = this._selectedMethod() === "pickup"

    if (this.hasDeliveryPanelTarget) {
      this.deliveryPanelTarget.classList.toggle("hidden", isPickup)
      this._setFieldsRequired(this.deliveryPanelTarget, !isPickup)
    }
    if (this.hasPickupPanelTarget) {
      this.pickupPanelTarget.classList.toggle("hidden", !isPickup)
      this._setFieldsRequired(this.pickupPanelTarget, isPickup)
    }

    this._updatePickupHint()
    this.element.dispatchEvent(new CustomEvent("checkout-fulfillment-method:changed", { bubbles: true }))
  }

  updateHint() {
    this._updatePickupHint()
  }

  _selectedMethod() {
    const selected = this.element.querySelector('input[name="checkout[fulfillment_method]"]:checked')
    return selected?.value || "delivery"
  }

  _updatePickupHint() {
    if (!this.hasPickupHintTarget) return

    const select = this.element.querySelector('select[name="checkout[pickup_point_id]"]')
    const pointId = select?.value
    const data = this.hasPointsValue ? this.pointsValue[pointId] : null

    if (data) {
      this.pickupHintTarget.textContent = [data.address, data.instructions].filter(Boolean).join(" · ")
      this.pickupHintTarget.classList.remove("hidden")
    } else {
      this.pickupHintTarget.textContent = ""
      this.pickupHintTarget.classList.add("hidden")
    }
  }

  _setFieldsRequired(panel, required) {
    panel.querySelectorAll("input, select, textarea").forEach((field) => {
      if (field.dataset.fulfillmentOptional === "true") return
      if (field.type === "hidden") return

      if (required) {
        field.setAttribute("required", "required")
      } else {
        field.removeAttribute("required")
      }
    })
  }
}
